import React, {useState, useCallback, useMemo,useEffect,useRef } from "react";
import { useDispatch } from "react-redux";
import { RESET_SEARCH } from "../Redux/Actions/types";
const AutocompleteInput = ({
  label,
  name,
  value,
  placeholder,
  suggestions, 
  onInputValueChange,
  onSelectSuggestion,
  onFocus, 
  onOthersSelect
}) => {
  const showList = (suggestions?.length ?? 0) > 0;
  const [text,setText] = useState('')
  const [othersValue,setOthersValue] = useState('')
  const dispatch = useDispatch()
  const searchRef = useRef(null);

// Add useEffect to handle outside clicks
useEffect(() => {
  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      dispatch({ type: RESET_SEARCH });
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [dispatch]);
  const handleChange = useCallback(
    (e) => onInputValueChange(e.target.value),
    [onInputValueChange]
  );
  const handleOthersChange = useCallback(
    (e) => {
      onOthersSelect(e.target.value);
      setOthersValue(e.target.value);
    },
    [onOthersSelect]
  );

  const items = useMemo(() => suggestions || [], [suggestions]);

  return (
    <>
    <div className="form-group">
      <label htmlFor={name}>{label}</label>

      <div className="position-relative">
        <input
          id={name}
          ref={searchRef}
          type="text"
          name={name}
          onFocus={onFocus}
          className="form-control bg-white mb-3"
          placeholder={placeholder}
          value={value || ""}
          onChange={handleChange}
          autoComplete="off"
        />

        {showList && (
          <ul
            className="list-group position-absolute w-100"
            style={{ maxHeight: 200, overflowY: "auto", zIndex: 1000, top: "100%" }}
          >
            {items.map((item) => (
              <li
                key={item.object_id ?? item.object_name}
                className="list-group-item list-group-item-action"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  onSelectSuggestion(item)
                  setText(item.object_name)
                }}
                style={{ cursor: "pointer" }}
              >
                {item.object_name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
        {(text || "").trim().toLowerCase() === "others" && (
  <div className="form-group">

      <label>Specify {label}</label>

      <div className="position-relative">
        <input
          id={name}
          type="text"
          name={name}
          className="form-control bg-white mb-3"
          // placeholder={placeholder}
          value={othersValue || ""}
          onChange={handleOthersChange}
          autoComplete="off"
        />
        </div>
        </div>)}
    </>
  );
};

export default AutocompleteInput;
